export default __webpack_public_path__ + "static/media/loadingBartone2.6db29d37.svg";